import long from 'long'

export type Long = string

export const longGt = (a: string, b: string) => long.fromString(a).gt(b)

export const isLong = (val?: string | null): val is Long => !!val && /^(\d{1,19})$/.test(val)
